export default "__VITE_ASSET__BmXDgjky__"